import { Box } from "@mui/material"
import { useEffect } from "react";
import Tour from 'reactour';
import { key } from "../../../core/Env";
import { createPersonalization } from "../../../core/request/Global";

const accentColor = "#64CC90";

export const TourPersonalization = ({isSteps, onboarding, uid}) => {
    // eslint-disable-next-line
    // const [prevBtnStat, setPrevBtnStat] = useState(false);

    const closeTour = async() => {
        let prsnl_data = {
            user_id: uid, 
            tool_id: key('tid'), 
            feature_name: 'onboarding', 
            personalization:[
                {sf_name: 'profiling', status: 1},
                {sf_name: 'welcome', status: 1},
                {sf_name: 'home_tour', status: 1},
            ]
        }
        await createPersonalization(prsnl_data);

        let onb = {...onboarding.data}
        onb.home_tour = {...onb.home_tour, stat: false, drawer: false}
        onboarding.set(onb)
    };

    useEffect(() => {
        isSteps.set(isSteps.data.map((v, index) => { return {...v, content: <PszContent k={index} name={v.name} desc={v.desc} len={isSteps.data.length} /> } } )  )
        // eslint-disable-next-line
    }, [])

  return (
    <Box>
        <Tour
            steps={isSteps.data}
            // isOpen={true}
            isOpen={(onboarding.data.home_tour.stat && !onboarding.data.home_tour.drawer)}
            closeWithMask={false}
            onRequestClose={() => closeTour()}
            lastStepNextButton={
                <Box display="flex" justifyContent="space-between" gap={2}> 
                    <Box className="btn-close" onClick={closeTour}>Close</Box>
                    <Box className="btn-next" color="primary" onClick={closeTour}>Got it</Box>
                </Box>
            }
            showNavigation={false}
            showNumber={false}
            disableInteraction={true}
            nextButton={
                <Box display="flex" justifyContent="space-between" gap={2}> 
                    <Box className="btn-close" onClick={closeTour}>Close</Box>
                    <Box className="btn-next" onClick={() => {/* Handle Next */}}>Next</Box>
                </Box>
            }
            showCloseButton={false}
            // getCurrentStep={(c)=>handler(c)}
            className="helper"
            rounded={5}
            accentColor={accentColor}
            prevButton={<Box></Box>}
        />
    </Box>
  )
}

const PszContent = ({k, name, desc, len}) =>{
    return (
        <Box>
            <Box display='flex' justifyContent='space-between'>
                <Box fontSize={16} fontWeight={800} color="#537192"> {name} </Box>
                <Box fontSize={12}> {k + 1} of {len}  </Box>
            </Box>
            <Box fontSize={14} mt={2}> {desc} </Box>
        </Box>
    )
}